module.exports = {"commentMaxLength":250,"validationMsg":{"login":{"userId":{"required":"ユーザーIDが未入力です"},"password":{"required":"パスワードが未入力です"}},"deliveryImageLoginSp":{"caseNumberLastFourDigit":{"required":"キー情報が未入力です"}}},"applicationMsg":{"noResults":"検索条件に一致する案件が見つかりませんでした。\n検索条件を変更して検索を実行してください。"},"csvForFrenetMsg":{"alert":"ロット上げ数量が計上部署の振り分け合計数量に満たない商材があります。","question":"フレネットHIBIYAに発注いたします。\nよろしいですか。","execution":"発注処理中です。\n発注処理の結果は発注履歴画面の\n「フレネット連携実施結果」\nで確認してください。"},"csvForOthersMsg":{"alert":"ロット上げ数量が計上部署の振り分け合計数量に満たない商材があります。"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/consts.json
// module id = y5rj
// module chunks = 1